import { environment } from '../../environments/environment';
import {
  ApiResponse,
  GetBasiqAuthLinkFn,
  RefreshBasiqConnectionsFn,
  GetBasiqManageConsentLinkFn,
  Send2FaCodeToBusinessUserFn,
  Verify2FaCodeToIndividualFn,
  Verify2FaCodeToIndividualRequest,
} from '@portal-workspace/grow-shared-library';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { httpOptions } from '@portal-workspace/grow-ui-library';
import { BasiqManageConsentRequest, PayloadApiResponse } from '@portal-workspace/grow-shared-library';
import { map } from 'rxjs/operators';

const apiHost = environment.api2Host;

const URL_GET_BASIQ_AUTH_LINK = (id: string) => `${apiHost}/api2/get-basiq-auth-link/${id}`;
const URL_GET_BASIQ_MANAGE_CONSENT_LINK = (abn: string) => `${apiHost}/api2/get-basiq-manage-consent-link/${abn}`;
const URL_SEND_2FA_CODE_TO_BUSINESS_USER = () => `${apiHost}/api2/send-2fa-code-to-business-user`;
const URL_VERIFY_2FA_CODE_TO_INDIVIDUAL = () => `${apiHost}/api2/verify-2fa-code-to-individual`;
const URL_REFRESH_BASIQ_CONNECTIONS = (userId: string, type: 'business' | 'consumer') => `${apiHost}/api2/refresh-basiq-connections/${userId}/${type}`;

@Injectable()
export class BasiqService {

  constructor(private httpClient: HttpClient) { }

  getBasiqAuthLinkFn: GetBasiqAuthLinkFn = (id: string) => {
    return this.getBasiqAuthLink(id).pipe(map(r => r))
  }

  getBasiqAuthLink(id: string): Observable<PayloadApiResponse<string | null>> {
    return this.httpClient.get<PayloadApiResponse<string | null>>(URL_GET_BASIQ_AUTH_LINK(id), httpOptions()).pipe();
  }

  refreshBasiqConnectionsFn: RefreshBasiqConnectionsFn = (userId: string, type: 'business' | 'consumer') => this.refreshBasiqConnections(userId, type)

  refreshBasiqConnections(userId: string, type: 'business' | 'consumer'): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_REFRESH_BASIQ_CONNECTIONS(userId, type), {}, httpOptions()).pipe();
  }

  getBasiqManageConsentLinkFn: GetBasiqManageConsentLinkFn = (abn: string) => {
    return this.getBasiqManageConsentLink(abn).pipe(map(r => r))
  }

  getBasiqManageConsentLink(abn: string): Observable<PayloadApiResponse<string | null>> {
    return this.httpClient.post<PayloadApiResponse<string | null>>(URL_GET_BASIQ_MANAGE_CONSENT_LINK(abn), httpOptions()).pipe();
  }
  
  send2FaCodeToBusinessUserFn: Send2FaCodeToBusinessUserFn = (request:BasiqManageConsentRequest) => {
    return this.send2FaCodeToBusinessUser(request).pipe(map(r => r))
  }

  send2FaCodeToBusinessUser(request:BasiqManageConsentRequest): Observable<PayloadApiResponse<{mobileNumber: string, email: string} | null>> {
    return this.httpClient.post<PayloadApiResponse<{mobileNumber: string, email: string} | null>>(URL_SEND_2FA_CODE_TO_BUSINESS_USER(), request, httpOptions()).pipe();
  }

  verify2FaCodeToIndividualFn: Verify2FaCodeToIndividualFn = (request: Verify2FaCodeToIndividualRequest) => {
    return this.verify2FaCodeToIndividual(request).pipe(map(r => r))
  }

  verify2FaCodeToIndividual(request: Verify2FaCodeToIndividualRequest): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_VERIFY_2FA_CODE_TO_INDIVIDUAL(), request, httpOptions()).pipe();
  }
}

